import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconHouseRoundFill = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12.537 4.155a1 1 0 0 0-1.074 0L4.461 8.61a1 1 0 0 0-.463.843v9.548a1 1 0 0 0 1 1h14.004a1 1 0 0 0 1-1V9.454a1 1 0 0 0-.463-.843l-7.002-4.456ZM9.25 13.75a1 1 0 0 1 1-1h3.5a1 1 0 1 1 0 2h-3.5a1 1 0 0 1-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconHouseRoundFill);
export default Memo;
